import Config from '../Config';
import { RestService } from './RestService';

export const ImportService = {
    import: async function(body){
        return RestService.post(`${Config.upload_url}`, {}, body)
        .then(response => response.json())
    },
    importMap: async function(body){
        return RestService.post(`${Config.upload_map_url}`, {}, body)
        .then(response => response.json())
    },
    uploadProductImage: async function(body){
        return RestService.post(`${Config.upload_product_url}`, {}, body)
        .then(response => response.json())
    },
    reassignRoutes: async function(body){
        return RestService.post(`${Config.reassign_routes}`, {}, body)
        .then(response => response.json())
    },
    fetchPredictions: async function(route_id, schedule_date){
        return RestService.get(`${Config.get_predictions}route_id=${route_id}&schedule_date=${schedule_date}`, {})
        .then(response => response.json());
    },
    importLedger: async function(type, header, body){
        return RestService.post(`${Config.upload_ledger_url}type=${type}`, header, body)
        .then(response => response.json())
    },
};